import { memo } from "react";
import styles from "./stepBackBtn.module.scss";

const StepBackBtn = memo((props: StepBackBtnProps) => {
  const {onClick, label = "Back to previous step", disabled = false} = props;

  return(
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={styles.back}
    >‹ {label}</button>
  )
});

export default StepBackBtn;

interface StepBackBtnProps {
  onClick: () => void;
  label?: string;
  disabled?: boolean;
}